import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import Select from "react-select";
import Swal from "sweetalert2";
import ReactDatetime from "react-datetime";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  OverlayTrigger,
  Tooltip,
  Modal,
  FormControl,
} from "react-bootstrap";
import { number } from "prop-types";
import DetailPengajuan from "./TabPengajuan/indexSteps";
import { useDispatch, useSelector } from "react-redux";
import { getAllPengajuan } from "stores/Pengajuan/function";
import { getAllStatusPengajuan } from "stores/Pengajuan/function";
import { Dna, InfinitySpin, LineWave, Oval } from "react-loader-spinner";
import { cekStatusPengajuan } from "stores/Pengajuan/function";
import ReactPaginate from "react-paginate";
import "./Pagination.css";
import { mirage, quantum } from "ldrs";
import { getAllJson } from "stores/Pengajuan/function";
import updateLogo from "../../../assets/img/changes.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cekUpdateDataBpd } from "stores/Pengajuan/function";
import CryptoJS from "crypto-js";
import { getScoringByLoan } from "stores/Pengajuan/function";
import { isiStatusSlikNasabah } from "stores/Pengajuan/function";

function Pengajuan() {
  quantum.register();
  // ++++++FILTER LOCAL STORAGE ++++++++
  const filterLocalStorage = () => {
    const filter = localStorage.getItem("filters");
    if (filter) return JSON.parse(filter);
    return {
      searchText: "",
      filterTujuanPenggunaan: null,
      pilihOpsi: null,
    };
  };

  const itemsPerPage = 10;
  const modalDetailPengajuan = useSelector((state) => state.pengajuanReducer);
  const refreshPengajuan = useSelector(
    (state) => state.pengajuanReducer.modalDetailPengajuan,
  );
  const auth = useSelector((state) => state.authReducer);
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const dispatch = useDispatch();
  const [listPengajuan, setListPengajuan] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState(
    filterLocalStorage().pilihOpsi
      ? {
        value: filterLocalStorage().pilihOpsi,
        label:
          filterLocalStorage().pilihOpsi || filterLocalStorage().pilihOpsi,
      }
      : null,
  );
  const [filterTujuanPenggunaan, setFilterTujuanPenggunaa] = React.useState(
    filterLocalStorage().filterTujuanPenggunaan
      ? {
        value: filterLocalStorage().filterTujuanPenggunaan.value,
        label:
          filterLocalStorage().filterTujuanPenggunaan.label ||
          filterLocalStorage().filterTujuanPenggunaan.label,
      }
      : null,
  );
  const [listStatus, setListStatus] = React.useState([]);
  const [listTujuanPenggunaan, setListTujuanPenggunaan] = React.useState([]);
  const [searchText, setSearchText] = React.useState(
    filterLocalStorage().searchText,
  );
  const [loading, setLoading] = React.useState(true);
  const [modalCekStatus, setModalCekStatus] = React.useState(false);
  const [modalCekUpdateData, setModalUpdateData] = React.useState(false);
  const [hasilCekStatus, setHasiCekStatus] = React.useState(null);
  const [detailPengajuan, setDetailPengajuan] = React.useState(null);
  const [pending, setPending] = React.useState(false);
  //Testing Pagination
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [pilihOpsi, setPilihOpsi] = React.useState("");
  const [pilihTujuanPenggunaan, setPilihTujuanPenggunaan] = React.useState("");
  const [hours, setHours] = React.useState(0);

  const incrementHours = () => setHours((prev) => prev + 1);
  const decrementHours = () => setHours((prev) => (prev > 0 ? prev - 1 : 0));

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const openDetailPengajuan = pengajuan.closeTabPengajuan;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };
  // ============== Clear Filters ========================
  React.useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("filters"); // hapus 1 key
      // atau clear semua:
      // localStorage.clear();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // ========================================================
  const handleFilterChange = () => {
    localStorage.setItem(
      "filters",
      JSON.stringify({ searchText, filterTujuanPenggunaan, pilihOpsi }),
    );

    setPending(true);
    setPage(0);
    getAllPengajuan(dispatch, {
      status: pilihOpsi,
      page: 1,
      limit: totalPerHalaman,
      cari: searchText,
      tujuanPenggunaan: pilihTujuanPenggunaan,
      kategoriKredit: "",
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const saveToLocalStorage = (data) => {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      "your-secret-key",
    ).toString();
    localStorage.setItem("detailPengajuan", encryptedData);
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
    dispatch({ type: "SET_DETAIL_PENGAJUAN", data: val });
    dispatch({ type: "SET_CLOSE_TAB", data: true });
    dispatch({ type: "SET_LAST_TAB", data: "konvensional" });
    dispatch({ type: "HIDE_DOKUMEN" });
    localStorage.setItem("lastPage", "detail");
    saveToLocalStorage(val);
    // const encryptedData = CryptoJS.AES.encrypt(
    //   JSON.stringify(val),
    //   "your-secret-key"
    // ).toString();
    // localStorage.setItem("detailPengajuan", encryptedData);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleSubmit = () => {
    Swal.fire({
      title: "Konfirmasi Update",
      text: "Pastikan Jam yang anda kirim benar !!!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Update",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          text: "Mohon tunggu, sedang dicek.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        cekUpdateDataBpd({
          jam: hours,
        }).then((response) => {
          Swal.close();
          if (response.data.status === 200) {
            Swal.fire({
              title: "Berhasil",
              text: response.data.message,
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: response.data.message,
              icon: "error",
            });
          }
        });
        handleCloseModalUpdatStatus();
        getAllPengajuan(dispatch, {
          status:
            filterStatus === null || filterStatus.value === ""
              ? ""
              : filterStatus.value,
          cari: searchText,
          page: page + 1,
          limit: totalPerHalaman,
          tujuanPenggunaan: pilihTujuanPenggunaan,
          // tujuanPenggunaan:
          //   filterTujuanPenggunaan === null ||
          //   filterTujuanPenggunaan.value === ""
          //     ? ""
          //     : filterTujuanPenggunaan.value,
          kategoriKredit: "",
        }).catch((err) => {
          Swal.close();
          console.log("ERRORRRRR", err);
          Swal.fire({
            title: "Error",
            text: "Terjadi kesalahan saat mengajukan pengajuan.",
            icon: "error",
          });
        });
      }
    });
  };

  // Tambahkan parameter id langsung ke fungsi
  const handleSlikSubmit = (idTarget) => {
    Swal.fire({
      title: "Memproses...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    isiStatusSlikNasabah({
      id_pinjaman: idTarget,
    })
      .then((response) => {
        // Sesuaikan pengecekan status (biasanya 200 atau response.data.status === 200)
        if (response.status === 200 || response.data.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Berhasil!",
            text: response.data.message || "Status SLIK berhasil diperbarui",
            showConfirmButton: false,
            timer: 1500,
          });

          // Refresh data table
          getAllPengajuan(dispatch, {
            status: filterStatus?.value || "",
            cari: searchText,
            page: page + 1,
            limit: totalPerHalaman,
            tujuanPenggunaan: pilihTujuanPenggunaan,
            kategoriKredit: "",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: response.data.message || "Terjadi kesalahan pada server",
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Koneksi ke server terputus atau terjadi kesalahan.",
        });
      });
  };

  React.useEffect(() => {
    const storedDetail = localStorage.getItem("detailPengajuan");

    if (storedDetail) {
      const bytes = CryptoJS.AES.decrypt(storedDetail, "your-secret-key");
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      // Mengupdate Redux state dengan data dari localStorage
      dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
      dispatch({ type: "SET_DETAIL_PENGAJUAN", data: decryptedData });
    }
  }, []);

  React.useEffect(() => {
    if (pengajuan.listPengajuan.data) {
      let tmp = pengajuan.listPengajuan.data.map((val) => {
        let tmpTanggalPengajuanBpd = "";
        let updateBy = "";
        for (var i = 0; i < val.history.length; i++) {
          if (val.history[i].status === "Diproses") {
            tmpTanggalPengajuanBpd = val.history[i].date;
            break;
          }
        }
        for (var i = 0; i < val.history.length; i++) {
          if (val.history[i].status === "Disetujui") {
            updateBy = val.history[i].keterangan;
            break;
          }
        }

        const isCekStatusDisabled =
          val.statusPengajuan !== "Diproses" &&
          val.statusPengajuan !== "Disetujui";

        return {
          ...val,
          namaCabangPencairan: !val.lokasiPencairan
            ? "-"
            : val.lokasiPencairan.namaCabang,
          tanggalPengajuanBpd:
            tmpTanggalPengajuanBpd === ""
              ? "-"
              : moment(new Date(tmpTanggalPengajuanBpd)).format("DD MMMM YYYY"),
          tanggalPencairan:
            val.statusPengajuan === "Disetujui"
              ? moment(new Date(val.tglAkad)).format("DD MMMM YYYY")
              : "-",
          diupdateOleh: updateBy === "" ? "-" : updateBy,

          // --- ACTION 1 (DOKUMEN SERAH TERIMA) ---
          // action1: (
          //   <div className="d-flex justify-content-center">
          //     {val.stepEmpat.tujuanPenggunaan === "2" ? (
          //       <OverlayTrigger
          //         placement="top"
          //         overlay={<Tooltip>Dokumen Serah Terima</Tooltip>}
          //       >
          //         <Button
          //           className="btn-icon shadow-sm d-flex align-items-center justify-content-center"
          //           disabled={val.urlChecklist === "-"}
          //           style={{
          //             width: "36px",
          //             height: "36px",
          //             borderRadius: "10px",
          //             backgroundColor:
          //               val.urlChecklist === "-" ? "#E2E8F0" : "#C62D42",
          //             border: "none",
          //             color: "white",
          //             cursor:
          //               val.urlChecklist === "-" ? "not-allowed" : "pointer",
          //           }}
          //           onClick={() => window.open(val.urlChecklist, "_blank")}
          //         >
          //           <i
          //             className="fas fa-file-invoice"
          //             style={{ fontSize: "15px" }}
          //           ></i>
          //         </Button>
          //       </OverlayTrigger>
          //     ) : (
          //       "-"
          //     )}
          //   </div>
          // ),

          // --- ACTION UTAMA (DETAILS & CEK STATUS) ---
          action: (
            <div className="d-flex justify-content-center align-items-center">
              {/* BUTTON DETAIL */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Pengajuan</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    backgroundColor: "#F75D59",
                    border: "none",
                    color: "white",
                  }}
                  onClick={() => handleDetailsClick(val)}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>

              {/* BUTTON CEK STATUS (KHUSUS ADMIN) */}
              {(auth.role === "super admin" || auth.role === "admin") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Cek Status BPD</Tooltip>}
                >
                  <Button
                    className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                    disabled={isCekStatusDisabled}
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "10px",
                      backgroundColor: isCekStatusDisabled
                        ? "#E2E8F0"
                        : "#DCE8F4",
                      border: "none",
                      color: isCekStatusDisabled ? "#94A3B8" : "#02478E",
                      cursor: isCekStatusDisabled ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      let siapCek = {
                        idPinjaman: val.id_pinjaman,
                        nik: val.nomorIdentitas,
                      };
                      Swal.fire({
                        title: "Sinkronisasi Data...",
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                      });
                      cekStatusPengajuan(siapCek)
                        .then((response) => {
                          Swal.close();
                          if (response.status === 200) {
                            Swal.fire({
                              title: "Berhasil",
                              text: response.data.message,
                              icon: "success",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                            getAllPengajuan(dispatch, {
                              status: filterStatus?.value || "",
                              cari: "",
                              page: page + 1,
                              limit: totalPerHalaman,
                              kategoriKredit: "",
                            });
                            setModalCekStatus(!modalCekStatus);
                            setDetailPengajuan(val);
                            setHasiCekStatus(response.data);
                          } else {
                            Swal.fire({
                              title: "Gagal",
                              text: "Gagal melakukan cek status",
                              icon: "error",
                            });
                          }
                        })
                        .catch((error) => {
                          Swal.close();
                          console.error("Error:", error);
                        });
                    }}
                  >
                    <i
                      className="fas fa-sync-alt"
                      style={{ fontSize: "14px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}

              {/* BUTTON ISI STATUS SLIK (KHUSUS SUPER ADMIN & PRODUKTIF) */}
              {auth.role === "super admin" &&
                (val.stepEmpat?.tujuanPenggunaan == null ? (
                  <span className="mx-2 fw-bold text-muted">-</span>
                ) : val.stepEmpat?.tujuanPenggunaan === "2" ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Isi Status Slik</Tooltip>}
                  >
                    <Button
                      className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "10px",
                        backgroundColor: "#28a745", // Warna hijau agar beda dengan button detail
                        border: "none",
                        color: "white",
                      }}
                      onClick={() => {
                        Swal.fire({
                          title: "Konfirmasi SLIK",
                          text: `Apakah anda yakin ingin mengisi status SLIK untuk nasabah ${val.namaLengkap}?`,
                          icon: "question",
                          showCancelButton: true,
                          confirmButtonColor: "#28a745",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Ya, Setujui!",
                          cancelButtonText: "Batal",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Kita langsung panggil fungsi submit dengan melempar ID-nya
                            handleSlikSubmit(val.id_pinjaman);
                          }
                        });
                      }}
                    >
                      <i
                        className="fas fa-check-double"
                        style={{ fontSize: "14px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>
                ) : null)}
            </div>
          ),
        };
      });
      setListPengajuan(tmp);
    }
  }, [pengajuan.listPengajuan.data, auth, page, totalPerHalaman, filterStatus]);

  const handleCloseModalUpdatStatus = () => {
    setModalUpdateData(false);
    setHours(0);
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  React.useEffect(() => {
    let tmp = [
      // {
      //   value: "",
      //   isDisabled: false,
      // },
      {
        value: "Menunggu Konfirmasi",
        label: "Menunggu Konfirmasi",
      },
      {
        value: "Diajukan",
        label: "Diajukan",
      },
      {
        value: "Diproses",
        label: "Diproses",
      },
      {
        value: "Disetujui",
        label: "Disetujui",
      },
      {
        value: "Revisi",
        label: "Revisi",
      },
      {
        value: "Ditolak",
        label: "Ditolak",
      },
    ];
    setListStatus(tmp);
  }, [pengajuan.listPengajuan.data, page, totalPerHalaman]);

  React.useEffect(() => {
    let tmp = [
      // {
      //   value: "",
      //   isDisabled: false,
      // },
      {
        value: "1",
        label: "Konsumtif",
      },
      {
        value: "2",
        label: "Produktif",
      },
    ];
    setListTujuanPenggunaan(tmp);
  }, [pengajuan.listPengajuan.data, page, totalPerHalaman]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Menunggu Konfirmasi":
        return {
          backgroundColor: "#FFF5CD",
          textColor: "#FFAF05",
          fontWeight: "bold",
        };
      case "Diajukan":
        return {
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
          fontWeight: "bold",
        };
      case "Diproses":
        return {
          backgroundColor: "#fcceb3",
          textColor: "#fa5d02",
          fontWeight: "bold",
        };
      case "Disetujui":
        return {
          backgroundColor: "#E3FCDB",
          textColor: "#5AC967",
          fontWeight: "bold",
        };
      case "Revisi":
        return {
          backgroundColor: "#FFE2E6",
          textColor: "#FF2B4B",
          fontWeight: "bold",
        };
      case "Ditolak":
        return {
          backgroundColor: "#E10F00",
          textColor: "#ffffff",
          fontWeight: "bold",
        };
      default:
        return {};
    }
  };

  const getStatusConvertStyle = (status) => {
    switch (status) {
      case "":
        return {
          backgroundColor: "#FFEEE6",
          textColor: "#FF4F00",
          fontWeight: "bold",
        };
      case "gagal":
        return {
          backgroundColor: "#E10F00",
          textColor: "#ffffff",
          fontWeight: "bold",
        };
      case "sukses":
        return {
          backgroundColor: "#E3FCDB",
          textColor: "#5AC967",
          fontWeight: "bold",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTop: "1px solid #E3E6F0",
        minHeight: "50px",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "12px", // Ukuran font diperkecil sedikit agar kolom muat banyak
        color: "#4E73DF",
        textTransform: "uppercase",
        justifyContent: "flex-start",
        padding: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        "&:hover": {
          backgroundColor: "#F8FAFC",
        },
      },
    },
    cells: {
      style: {
        fontSize: "12px", // Font sel 12px agar rapi
        color: "#475569",
        justifyContent: "flex-start",
        padding: "8px",
      },
    },
  };

  const colPengajuan = [
    {
      name: "NO",
      width: "100px",
      center: true,
      selector: (row, index) => index + pengajuan.listPengajuan.pagingCounter,
    },
    {
      name: "Referensi ID",
      minWidth: "270px",
      center: true,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center">
          <b className="text-dark mr-2" style={{ fontSize: "13px" }}>
            {row.id_pinjaman}
          </b>
          <OverlayTrigger placement="top" overlay={<Tooltip>Salin ID</Tooltip>}>
            <i
              className="far fa-copy text-muted"
              style={{
                cursor: "pointer",
                fontSize: "14px",
                transition: "color 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.className = "far fa-copy text-primary")
              }
              onMouseOut={(e) =>
                (e.currentTarget.className = "far fa-copy text-muted")
              }
              onClick={() => {
                navigator.clipboard.writeText(row.id_pinjaman);
                Swal.fire({
                  title: "Tersalin!",
                  text: `ID ${row.id_pinjaman} berhasil disalin`,
                  icon: "success",
                  timer: 1000,
                  showConfirmButton: false,
                  position: "center",
                  width: "500px",
                });
              }}
            ></i>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      name: "CALON NASABAH",
      minWidth: "270px",
      center: false, // Memastikan header dan cell rata kiri
      cell: (row) => (
        <div className="w-100 py-2 d-flex justify-content-start align-items-center">
          <span
            className="fw-900 text-dark ml-1"
            style={{
              fontSize: "15px",
              // letterSpacing: "-0.3px",
            }}
          >
            {row.namaLengkap}
          </span>
        </div>
      ),
    },
    {
      name: "TUJUAN",
      minWidth: "150px",
      center: true,
      cell: (row) => {
        const tujuan = row?.stepEmpat?.tujuanPenggunaan;
        if (tujuan == null) {
          return "-";
        }

        const isKonsumtif = tujuan === "1";
        return (
          <span
            className={`badge ${isKonsumtif ? "bg-info" : "bg-success"} text-white px-3 py-2`}
            style={{ borderRadius: "8px", fontSize: "11px" }}
          >
            {isKonsumtif ? "KONSUMTIF" : "PRODUKTIF"}
          </span>
        );
      },
    },
    {
      name: "CABANG PENCAIRAN",
      minWidth: "260px",
      center: false, // Ubah jadi false agar header dan cell rata kiri
      cell: (row) => (
        <div className="w-100 d-flex justify-content-start align-items-center">
          <div
            className="px-3 py-1 rounded-pill bg-light border fw-700 text-dark d-flex align-items-center"
            style={{
              fontSize: "13px",
              minWidth: "fit-content", // Agar pill menyesuaikan panjang teks
              marginLeft: "5px", // Sedikit margin agar tidak nempel garis tabel
            }}
          >
            <i className="fas fa-university mr-2 text-primary"></i>
            {row.namaCabangPencairan}
          </div>
        </div>
      ),
    },
    {
      name: "SALES MARKETING",
      minWidth: "250px",
      center: false,
      cell: (row) => (
        <div className="text-center">
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {row.marketing.nama}
          </div>
        </div>
      ),
    },
    {
      name: "SALES SUPERVISOR",
      minWidth: "250px",
      center: false,
      cell: (row) => (
        <div className="text-center">
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {row.supervisor.nama}
          </div>
        </div>
      ),
    },
    {
      name: "TGL PENGAJUAN (SPV)",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className=""
          style={{ fontSize: "14px", color: "#334155", fontWeight: "700" }}
        >
          {moment(new Date(row.createdAt)).format("DD MMM YYYY")}
        </span>
      ),
    },
    {
      name: "TGL PENGAJUAN (BPD)",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className=""
          style={{ fontSize: "14px", color: "#334155", fontWeight: "700" }}
        >
          {row.tanggalPengajuanBpd || "-"}
        </span>
      ),
    },
    {
      name: "TGL PENCAIRAN",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className=" text-success"
          style={{ fontSize: "14px", fontWeight: "900" }}
        >
          {row.tanggalPencairan || "-"}
        </span>
      ),
    },
    {
      name: "DIUPDATE OLEH",
      minWidth: "150px",
      center: true,
      cell: (row) => (
        <span
          className="badge badge-info px-2 py-1"
          style={{ fontSize: "12px", fontWeight: "700" }}
        >
          {row.diupdateOleh || "-"}
        </span>
      ),
    },
    {
      name: "Status",
      minWidth: "170px",
      center: true,
      cell: (row) => {
        const statusStyle = getStatusStyle(row.statusPengajuan);
        return (
          <div
            style={{
              fontWeight: "800",
              fontSize: "10px",
              textTransform: "uppercase",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              width: "130px",
              textAlign: "center",
              border: `1px solid ${statusStyle.textColor}44`,
            }}
          >
            {row.statusPengajuan}
          </div>
        );
      },
    },
    {
      name: "Dokumen Serah Terima",
      minWidth: "200px",
      center: true,
      cell: (row) => row.action1,
    },
    // {
    //   name: "Status Upload SLIK",
    //   minWidth: "150px",
    //   center: true,
    //   cell: (row) => {
    //     if (!row.scoring) return "-";
    //     let statusText =
    //       row.scoring.statusSlik === ""
    //         ? "Proses"
    //         : row.scoring.statusSlik === "gagal"
    //           ? "Gagal"
    //           : "Sukses";
    //     const statusStyle = getStatusConvertStyle(row.scoring.statusSlik);
    //     return (
    //       <div
    //         style={{
    //           fontWeight: "800",
    //           fontSize: "10px",
    //           backgroundColor: statusStyle.backgroundColor,
    //           color: statusStyle.textColor,
    //           padding: "5px 10px",
    //           borderRadius: "6px",
    //           width: "80px",
    //           textAlign: "center",
    //         }}
    //       >
    //         {statusText.toUpperCase()}
    //       </div>
    //     );
    //   },
    // },
    {
      name: "Aksi",
      minWidth: "120px",
      center: true,
      cell: (row) => row.action,
    },
  ];

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "10px",
      minHeight: "40px",
      height: "40px",
      border: "none",
      boxShadow: "none",
      fontSize: "14px",
    }),
  };

  React.useState(() => {
    getAllJson(dispatch);
  }, []);

  React.useEffect(() => {
    setPending(true);
    getAllPengajuan(dispatch, {
      status:
        filterStatus === null || filterStatus.value === ""
          ? ""
          : filterStatus.value,
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
      tujuanPenggunaan: pilihTujuanPenggunaan,
      // tujuanPenggunaan:
      //   filterTujuanPenggunaan === null || filterTujuanPenggunaan.value === ""
      //     ? ""
      //     : filterTujuanPenggunaan.value,
      kategoriKredit: "",
    })
      .then((response) => {
        // setLoading(false);
        setPending(false);
      })
      .catch((error) => {
        // setLoading(false);
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [modalDetailPengajuan.modalDetailPengajuan, page, totalPerHalaman]);

  // React.useEffect(() => {
  //   getAllPengajuan(dispatch, { status: "" });
  // }, [modalDetailPengajuan.modalDetailPengajuan]);

  return (
    <>
      <Modal
        size="md"
        show={modalCekUpdateData}
        onHide={() => {
          setModalUpdateData(false);
          handleCloseModalUpdatStatus();
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-history fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Update Data Pengajuan</h3>
            <p className="text-muted small">
              Tarik data pengajuan dari sistem Core Banking
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <div className="text-center">
                <label className="fw-bold text-dark d-block mb-3">
                  Jam Ke Belakang:
                </label>

                <div
                  className="d-flex align-items-center justify-content-center bg-light p-3"
                  style={{ borderRadius: "15px" }}
                >
                  <Button
                    variant="white"
                    onClick={decrementHours}
                    className="shadow-sm border-0 d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "12px",
                      color: "#1D3557",
                    }}
                  >
                    <i className="fas fa-minus"></i>
                  </Button>

                  <div className="mx-4 text-center">
                    <span
                      style={{
                        fontSize: "2.5rem",
                        fontWeight: "800",
                        color: "#1D3557",
                      }}
                    >
                      {hours}
                    </span>
                    <div className="fw-bold text-muted small mt--1">JAM</div>
                  </div>

                  <Button
                    variant="white"
                    onClick={incrementHours}
                    className="shadow-sm border-0 d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "12px",
                      color: "#1D3557",
                    }}
                  >
                    <i className="fas fa-plus"></i>
                  </Button>
                </div>
              </div>

              <Button
                className="btn-block p-3 mt-4 text-white border-0 shadow-sm"
                style={{
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  letterSpacing: "0.5px",
                }}
                onClick={handleSubmit}
              >
                MULAI UPDATE DATA
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalCekStatus}
        onHide={() => setModalCekStatus(!modalCekStatus)}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#53ABA0",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(83, 171, 160, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-search-dollar fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Hasil Cek Status</h3>
            <p className="text-muted">
              Informasi terbaru langsung dari server BPD
            </p>
          </div>

          <Card
            className="border-0 shadow-sm overflow-hidden"
            style={{ borderRadius: "20px" }}
          >
            <Card.Body className="p-0">
              <div className="bg-white p-4">
                <Row className="mb-3">
                  <Col sm="4" className="text-muted fw-bold small uppercase">
                    Reference ID
                  </Col>
                  <Col sm="8" className="text-dark fw-800">
                    : {detailPengajuan?.id_pinjaman}
                  </Col>
                </Row>
                <Row className="mb-3 border-top pt-3">
                  <Col sm="4" className="text-muted fw-bold small uppercase">
                    Nama Nasabah
                  </Col>
                  <Col sm="8" className="text-dark fw-bold">
                    : {detailPengajuan?.namaLengkap}
                  </Col>
                </Row>
                <Row className="mb-0 border-top pt-3">
                  <Col sm="4" className="text-muted fw-bold small uppercase">
                    {hasilCekStatus &&
                      (hasilCekStatus.status === "101" ||
                        hasilCekStatus.status === "200")
                      ? "Status BPD"
                      : "Pesan Sistem"}
                  </Col>
                  <Col sm="8" className="d-flex align-items-center">
                    <span className="mr-2">:</span>
                    <span
                      className={`px-3 py-1 rounded-pill fw-800 shadow-sm ${hasilCekStatus?.status === "200" ? "bg-success text-white" : "bg-warning text-dark"}`}
                      style={{ fontSize: "12px" }}
                    >
                      {hasilCekStatus &&
                        (hasilCekStatus.status === "101" ||
                          hasilCekStatus.status === "200")
                        ? hasilCekStatus.keterangan
                        : hasilCekStatus?.message}
                    </span>
                  </Col>
                </Row>
              </div>
            </Card.Body>

            <Card.Footer className="bg-white border-0 p-4 pt-0">
              <Button
                className="btn-block p-3 text-white border-0 shadow-sm"
                style={{
                  backgroundColor: "#53ABA0",
                  borderRadius: "15px",
                  fontWeight: "800",
                }}
                onClick={() => {
                  setModalCekStatus(!modalCekStatus);
                  // Tetap jalankan fungsi asli refresh data kamu
                  getAllPengajuan(dispatch, {
                    status: filterStatus?.value || "",
                    cari: "",
                    page: page + 1,
                    limit: totalPerHalaman,
                    kategoriKredit: "",
                  });
                  window.location.reload();
                }}
              >
                SINKRONISASI SELESAI
              </Button>
            </Card.Footer>
          </Card>
        </Modal.Body>
      </Modal>

      {modalDetailPengajuan.modalDetailPengajuan ? (
        <>
          {!openDetailPengajuan && (
            <div className="px-3">
              {/* SECTION HEADER & UPDATE BUTTON */}
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 mt-1">
                <div>
                  <h4
                    className="fw-800 text-dark mb-0"
                    style={{
                      letterSpacing: "0.5px",
                      fontSize: "1.5rem",
                      fontWeight: "500",
                    }}
                  >
                    LIST PENGAJUAN KONVENSIONAL
                  </h4>
                  <p className="text-muted small">
                    Kelola dan filter data pengajuan nasabah secara real-time
                  </p>
                </div>

                {(auth.role === "super admin" || auth.nopeg === "05230394") && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Cek Sinkronisasi Data Terbaru</Tooltip>}
                  >
                    <Button
                      onClick={() => setModalUpdateData(!modalCekUpdateData)}
                      className="btn-fill shadow-sm border-0 d-flex align-items-center"
                      style={{
                        backgroundColor: "#A2CFFE",
                        color: "#1D3557",
                        borderRadius: "10px",
                        fontWeight: "700",
                        padding: "8px 20px",
                      }}
                    >
                      <i className="fas fa-sync-alt mr-2"></i> Update All Data
                    </Button>
                  </OverlayTrigger>
                )}
              </div>

              {/* SECTION FILTER CARD (DIBUAT COMPACT) */}
              <Card
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "15px", backgroundColor: "#F8F9FC" }}
              >
                <Card.Body className="p-3">
                  <Row className="align-items-end">
                    {/* Search Reference/Nasabah */}
                    <Col lg={4} md={6} className="mb-2 mb-lg-0">
                      <label className="fw-bold text-dark small ml-1">
                        Cari Nasabah
                      </label>
                      <InputGroup
                        className="bg-white border-0 shadow-none"
                        style={{ borderRadius: "10px", overflow: "hidden" }}
                      >
                        <Form.Control
                          className="border-0 bg-white"
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          onKeyDown={handleKeyDown}
                          placeholder="Ref ID / Nama Nasabah..."
                          style={{ height: "40px", fontSize: "14px" }}
                        />
                        {searchText && (
                          <InputGroup.Append>
                            <InputGroup.Text
                              className="bg-white border-0"
                              onClick={handleClearSearch}
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fas fa-times-circle text-muted"></i>
                            </InputGroup.Text>
                          </InputGroup.Append>
                        )}
                      </InputGroup>
                    </Col>

                    {/* Status Filter */}
                    <Col lg={3} md={6} className="mb-2 mb-lg-0">
                      <label className="fw-bold text-dark small ml-1">
                        Status
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        value={filterStatus}
                        onChange={(opt) => {
                          setFilterStatus(opt);
                          setPilihOpsi(opt.value);
                        }}
                        options={[
                          { value: "", label: "Semua Status" },
                          ...listStatus,
                        ]}
                        placeholder="Pilih Status"
                        styles={customSelectStyles}
                      />
                    </Col>

                    {/* Tujuan Penggunaan Filter */}
                    <Col lg={3} md={9} className="mb-2 mb-lg-0">
                      <label className="fw-bold text-dark small ml-1">
                        Tujuan Penggunaan
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        value={filterTujuanPenggunaan}
                        onChange={(opt) => {
                          setFilterTujuanPenggunaa(opt);
                          setPilihTujuanPenggunaan(opt.value);
                        }}
                        options={[
                          { value: "", label: "Semua Tujuan" },
                          ...listTujuanPenggunaan,
                        ]}
                        placeholder="Pilih Tujuan"
                        styles={customSelectStyles}
                      />
                    </Col>

                    {/* Search Button */}
                    <Col lg={2} md={3} className="text-right">
                      <Button
                        className="btn-block shadow-sm d-flex align-items-center justify-content-center"
                        onClick={handleFilterChange}
                        style={{
                          height: "40px",
                          backgroundColor: "#1D3557",
                          border: "none",
                          borderRadius: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        <i className="fas fa-search mr-2"></i> FILTER
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* SECTION DATA TABLE */}
              <Card
                className="border-0 shadow-sm overflow-hidden"
                style={{ borderRadius: "15px" }}
              >
                <Card.Body className="p-0">
                  {pending ? (
                    <div className="py-5 text-center">
                      <l-quantum
                        size="50"
                        speed="2.75"
                        color="#1D3557"
                      ></l-quantum>
                      <p className="mt-3 fw-bold text-muted">
                        Memuat data pengajuan...
                      </p>
                    </div>
                  ) : (
                    <>
                      <DataTable
                        columns={colPengajuan}
                        data={listPengajuan}
                        customStyles={customStyles}
                        progressPending={pending}
                        highlightOnHover
                        responsive
                      />

                      {/* CUSTOM PAGINATION FOOTER */}
                      <div className="px-4 py-3 bg-light border-top">
                        <Row className="align-items-center">
                          <Col
                            md={6}
                            className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0"
                          >
                            <span className="text-muted small fw-bold mr-3">
                              Tampilkan
                            </span>
                            <div style={{ width: "100px" }}>
                              <Select
                                menuPlacement="top"
                                classNamePrefix="react-select"
                                value={options.find(
                                  (opt) => opt.value === totalPerHalaman,
                                )}
                                onChange={handlePageSizeChange}
                                options={options}
                              />
                            </div>
                            <span className="text-muted small fw-bold ml-3">
                              per halaman
                            </span>
                          </Col>

                          <Col
                            md={6}
                            className="d-flex justify-content-center justify-content-md-end"
                          >
                            <ReactPaginate
                              forcePage={page}
                              pageCount={pengajuan.listPengajuan.totalPages}
                              onPageChange={(val) => setPage(val.selected)}
                              containerClassName="pagination mb-0"
                              pageClassName="page-item"
                              pageLinkClassName="page-link shadow-none border-0 mx-1 rounded"
                              activeClassName="active"
                              activeLinkClassName="bg-primary text-white"
                              previousLabel={
                                <i className="fas fa-chevron-left"></i>
                              }
                              nextLabel={
                                <i className="fas fa-chevron-right"></i>
                              }
                              disabledClassName="disabled"
                            />
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </div>
          )}
        </>
      ) : (
        <>
          <DetailPengajuan />
        </>
      )}
    </>
  );
}

export default Pengajuan;
